import FrameOverlay from "@/components/base/FrameOverlay";
import FadeIn from "@/components/base/FadeIn";
import TiltCard from "@/components/base/TiltCard";

export default function AboutArt() {
  return (
    <section id="bio" className="bg-background-100 py-24 md:py-36">
      <div className="px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center max-w-7xl mx-auto">
        {/* Image */}
        <FadeIn className="order-2 lg:order-1">
          <TiltCard className="aspect-[4/5] overflow-hidden" maxTilt={10} scale={1.03}>
            <img
              src="https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20contemplative%20digital%20artist%20at%20work%20surrounded%20by%20Renaissance%20paintings%20and%20modern%20screens%2C%20warm%20chiaroscuro%20lighting%2C%20moody%20artistic%20atmosphere%2C%20baroque%20style%20with%20contemporary%20elements%2C%20deep%20shadows%20and%20golden%20highlights&width=900&height=1200&seq=about-art-001&orientation=portrait"
              alt="About my art"
              className="w-full h-full object-cover object-top"
            />
            <FrameOverlay />
          </TiltCard>
        </FadeIn>

        {/* Text */}
        <div className="order-1 lg:order-2">
          <p className="font-display text-xs uppercase tracking-[0.25em] text-foreground-700 mb-6 title-eyebrow">
            ( 04 ) — Project Series
          </p>
          <h1 className="font-display font-black text-foreground-950 leading-[0.9] tracking-[-0.04em] text-[14vw] md:text-[10vw] lg:text-[9vw] mb-10 whitespace-nowrap">
            <span className="title-caps">YO.</span>
            <em className="font-serif italic font-light title-italic">bio</em>
          </h1>
          <p className="font-serif italic text-base md:text-lg text-foreground-700 mb-10 leading-relaxed">
            A quiet dialogue between eras — oil and algorithm sharing the same canvas.
          </p>
          <div className="space-y-5 text-foreground-700 text-base md:text-lg leading-relaxed font-serif">
            <p>
              My practice lives at the seam where oil and algorithm meet. I draw upon centuries of European portraiture, anatomical studies, and still-life tradition — then run them through the lens of generative systems.
            </p>
            <p>
              The result is a body of work that refuses to settle: at once familiar and strange, devotional and skeptical, classical and rendered.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-12 pt-12 border-t border-foreground-950/15">
            {[
              { n: "12", l: "Exhibitions" },
              { n: "240+", l: "Works" },
              { n: "08", l: "Awards" },
            ].map((s, i) => (
              <div key={i}>
                <div className="font-display font-black text-3xl md:text-5xl text-foreground-950 leading-none">
                  {s.n}
                </div>
                <div className="text-xs uppercase tracking-[0.18em] text-foreground-700 mt-2">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}